import { useEffect, useState } from 'react'

// local imports
import useDidMountEffect from 'utils/useDidMountEffect'
import { CampusServiceTypes, ICampusServiceReservations, ISecurityLocations } from 'types/TrackingType'
import DateUtil from 'utils/DateUtil'
import TracingService from 'service/TracingService'

export default function useCampusServiceTracing() {
  const [data, setData] = useState<ICampusServiceReservations[] | undefined>([])
  const [loading, setLoading] = useState<boolean>(false)

  const [selectedService, setSelectedService] = useState<CampusServiceTypes[]>([1, 2, 3, 4])
  const [endDate, setEndDate] = useState<Date | any | undefined>(new Date())
  const [selectedLocation, setSelectedLocation] = useState<ISecurityLocations | null>(null)
  const [startDate, setStartDate] = useState<Date | any | undefined>(new Date())

  /* Start - End Date validations?... */
  useDidMountEffect(() => startDate > endDate && setEndDate(startDate), [startDate])
  useDidMountEffect(() => endDate < startDate && setStartDate(endDate), [endDate])

  /* ########## Fetch Campus Services Reservations List ########## */
  const reqParams = {
    locationId: selectedLocation?.locationId || 0,
    startDate: startDate,
    endDate: DateUtil.getEndOfDay(endDate),
  }
  const fetchTableList = () => {
    setLoading(true)
    TracingService.getCampusServiceReservations(reqParams)
      .then((response) => {
        const respData = response.data.map((dt) => ({
          ...dt,
          _nameSurname: `${dt.employeeName} ${dt.employeeSurname}`,
        }))
        setData(respData)
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false))
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => fetchTableList(), [])

  return {
    selectedLocation,
    setSelectedLocation,
    selectedService,
    setSelectedService,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    /* Campus Services */
    fetchTableList,
    data,
    loading,
  }
}
